import React, { useContext, ReactNode } from "react";
import { isMobileOnly, isDesktop } from "react-device-detect"
import { Drawer } from "antd";
import { FaTimes } from "react-icons/fa";
import { ActionType, Enum } from "./../../resources/constants"
import language from "../../resources/languages/fa_IR";

// Components
import Filter from "../filter";
import SignIn from "../sign-in";
import Profile from "../profile";
import Booking from "../booking";
import Ticket from "../ticket";
import Support from "../support";
import Payment from "../payment";
import Safar30 from "../safar30";
import Request from "../request";

// Contexts
import GlobalContext from "../../contexts/global";

const { SET_OPEN_DRAWER } = ActionType
const { Enum: { Form } } = language
const { Form: { FILTER, SIGN_IN, BOOKING, PROFILE, SUPPORT, TICKET, PAYMENT, SAFAR30, REQUEST }} = Enum

function renderSwitch(form: string): ReactNode {
    switch(form) {
        case FILTER:
            return <Filter />;
        case SIGN_IN:
            return <SignIn />;
        case BOOKING:
            return <Booking />;
        case PROFILE:
            return <Profile />;
        case SUPPORT:
            return <Support />;
        case TICKET:
            return <Ticket />;
        case PAYMENT:
            return <Payment />;
        case SAFAR30:
            return <Safar30 />;
        case REQUEST:
            return <Request />;
        default:
            return false;
    }
}

export default function Index() {
    const { openDrawer, openTour, form, user, dispatch } = useContext(GlobalContext)

    return (
        <Drawer
            // @ts-ignore
            title={Form[form]}
            closeIcon={<FaTimes size={19} />}
            placement="right"
            size={isDesktop ? 'default' : undefined}
            width={isMobileOnly ? '100%' : undefined}
            zIndex={!openTour ? 9999 : 99999}
            open={(user && !user.complete) || openDrawer}
            onClose={() => dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: false }})}
        >
            {renderSwitch(form)}
        </Drawer>
    )
}
